// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendor" + "." + "6a323aa2891814a3773b" + ".css";
};